var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "account-manage-users" },
    [
      !_vm.loaded
        ? _c(
            "div",
            { staticClass: "layout-column flex-center loader" },
            [
              _c("rbv-loading", {
                attrs: { label: "Loading, please wait..." },
              }),
            ],
            1
          )
        : [
            _c("div", { staticClass: "header flex column" }, [
              _c("div", { staticClass: "flex row" }, [
                _c("div", { staticClass: "logo" }, [
                  _vm.userAccount && _vm.userAccount.account.logo
                    ? _c("img", {
                        attrs: { src: _vm.logo, alt: "Account Logo" },
                      })
                    : _c("div", [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("business"),
                        ]),
                      ]),
                ]),
                _c("div", { staticClass: "flex column" }, [
                  _c("div", { staticClass: "title" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.userAccount && _vm.userAccount.account.name
                        ) +
                        " "
                    ),
                  ]),
                  _c("div", { staticClass: "sub-title" }, [
                    _vm._v(" " + _vm._s(_vm.module.title) + " "),
                  ]),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "flex row controls" },
                [
                  _c(
                    "div",
                    { staticClass: "flex row" },
                    [
                      _c(
                        "dropdown-actions",
                        {
                          staticClass: "light",
                          attrs: { items: _vm.includedSorters, align: "left" },
                          model: {
                            value: _vm.sortBy,
                            callback: function ($$v) {
                              _vm.sortBy = $$v
                            },
                            expression: "sortBy",
                          },
                        },
                        [
                          _c("template", { slot: "value" }, [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("sort"),
                            ]),
                            _vm._v(" Sort By: "),
                            _c("b", [_vm._v(_vm._s(_vm.sortBy.label))]),
                          ]),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _vm.isFromRfpManager
                    ? [
                        _vm.canAccessRfpManager
                          ? _c(
                              "button",
                              {
                                staticClass: "button",
                                on: { click: _vm.openRfpManager },
                              },
                              [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("arrow_back"),
                                ]),
                                _vm._v(" Back to RFP Manager "),
                              ]
                            )
                          : _vm._e(),
                      ]
                    : _vm._e(),
                  _vm.isAdmin
                    ? _c(
                        "button",
                        {
                          staticClass: "button create",
                          on: { click: _vm.createNewUser },
                        },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("person_add"),
                          ]),
                          _vm._v(" Add New User "),
                        ]
                      )
                    : _vm._e(),
                ],
                2
              ),
            ]),
            _vm.users && _vm.userAccount
              ? _c("users-list", {
                  attrs: {
                    users: _vm.searchAndSortedUsers,
                    "search-term": _vm.searchTerm,
                    "sort-by": _vm.sortBy,
                    "user-account": _vm.userAccount,
                    "current-user-is-admin": _vm.isAdmin,
                  },
                  on: {
                    editUser: _vm.editUser,
                    confirmUser: _vm.confirmUser,
                    deactivateUser: _vm.deactivateUser,
                    resendInvitation: _vm.resendInvitation,
                    removeInvitation: _vm.removeInvitation,
                    changeAccountType: _vm.changeAccountType,
                  },
                })
              : _vm._e(),
            _c("div", { staticClass: "footer" }, [
              _c(
                "button",
                {
                  staticClass: "button",
                  on: { click: _vm.toggleDeactivatedUsers },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("person_off"),
                  ]),
                  _vm._v(
                    " " +
                      _vm._s(_vm.deactivatedUsersShown ? "Hide" : "Show") +
                      " Deactivated Users "
                  ),
                ]
              ),
              _vm.isNotAHotel
                ? _c("div", { staticClass: "autoVerification" }, [
                    _c("div", [
                      _vm._v("User Auto Verification is "),
                      _c(
                        "span",
                        {
                          class: _vm.account.userAutoVerification
                            ? "On"
                            : "Off",
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.account.userAutoVerification ? "ON" : "OFF"
                            )
                          ),
                        ]
                      ),
                    ]),
                    _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "button",
                          on: { click: _vm.manageAutoVerification },
                        },
                        [_vm._v(" Manage Auto Verification ")]
                      ),
                    ]),
                  ])
                : _vm._e(),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }